export default function RentalPolicies() {
    return (
        <div
            data-testid="rental-policies-page"
            className="mx-auto max-w-4xl px-4 pb-24 pt-16 sm:px-6 lg:px-8"
        >
            <div className="text-xs font-semibold uppercase tracking-widest text-[color:var(--brand-green)]">
                Rental Policies
            </div>
            <h1 className="mt-2 font-display text-4xl font-extrabold tracking-tight text-[color:var(--brand-navy)] sm:text-5xl">
                Simple, transparent policies
            </h1>
            <p className="mt-5 text-slate-600">
                Reserving with us should feel easy. Here&apos;s what to expect
                before, during, and after your rental.
            </p>

            <div className="mt-12 space-y-8">
                {[
                    {
                        title: "Reservations & Payments",
                        body: "All bookings are made online via secure Stripe checkout. Full payment is due at booking to reserve your scooter and hold your dates.",
                    },
                    {
                        title: "Cancellations & Refunds",
                        body: "Full refunds are available up to 48 hours before your delivery time. Cancellations within 48 hours receive a credit toward a future rental. No-shows are non-refundable.",
                    },
                    {
                        title: "Delivery & Pickup",
                        body: "We deliver fully-charged scooters to Orlando, Kissimmee, and Port Canaveral. A 30-minute delivery window will be confirmed the day before. Return pickup is scheduled at drop-off.",
                    },
                    {
                        title: "Damage & Loss",
                        body: "Normal wear is expected. Renter is responsible for damage caused by misuse, exposure to water beyond light rain, or loss of the scooter. Fee schedule available on request.",
                    },
                    {
                        title: "Age & Use Requirements",
                        body: "Renter must be 18+ and provide a valid government ID at delivery. Scooters may not be used under the influence, on unauthorized private property, or by riders exceeding the 400 lb weight capacity.",
                    },
                    {
                        title: "Support",
                        body: "If any issue comes up during your rental, call us right away — we'll do our best to support you and handle it promptly.",
                    },
                ].map((s) => (
                    <div
                        key={s.title}
                        data-testid={`policy-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                        className="card-surface p-8"
                    >
                        <h2 className="font-display text-xl font-extrabold text-[color:var(--brand-navy)]">
                            {s.title}
                        </h2>
                        <p className="mt-3 leading-relaxed text-slate-600">
                            {s.body}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}
